import { Outlet, createRootRoute, useMatches, useRouterState } from '@tanstack/react-router'

import { resolveAuthPolicyFromMatches } from '@/features/auth/policy'

import { AppShell } from '../AppShell'

export const Route = createRootRoute({
  component: RootLayout
})

function RootLayout() {
  const pathname = useRouterState({ select: state => state.location.pathname })
  const matches = useMatches()
  const authPolicy = resolveAuthPolicyFromMatches(matches, pathname)

  return (
    <AppShell authPolicy={authPolicy}>
      <Outlet />
    </AppShell>
  )
}
